import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { catchError, map, Observable, throwError } from "rxjs";
import { CompanyClient, ServiceRespose } from "../../shared";

@Injectable({
    providedIn: 'root'
})
export class CompanyService{
    http = inject(HttpClient);
    private readonly baseApiUrl = `${environment.userServiceApiBaseUrl}/api/company`;

    addCompanyDetails(companyDetails: CompanyClient): Observable<CompanyClient>{
        return this.http
            .post<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}`, companyDetails)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }

    getCompanies(userId: string): Observable<CompanyClient[]>{
        return this.http
            .get<ServiceRespose<CompanyClient[]>>(`${this.baseApiUrl}/all/${userId}`)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }

    getCompanyById(companyId: string): Observable<CompanyClient>{
        return this.http
            .get<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}/${companyId}`)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.errorMessage)))
            );
    }

    updateCompanyDetails(companyId: string, companyDetails: CompanyClient): Observable<CompanyClient>{
        return this.http
            .put<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}/${companyId}`, companyDetails)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }
}